import './facetwp.scss';

document.addEventListener('DOMContentLoaded', init);
function init() {

    if ( typeof FWP === "undefined" ) {
        return false;
    }

    const directoryFilters = document.querySelector( '.directory-filters' );
    const filterMobileClose = document.getElementById('filter-mobile-close');
    const searchFilterEl = document.querySelector('.directory-search-filter');
    const filterMobileTrigger = document.querySelector('.filter-trigger');

    console.log(directoryFilters);

    filterMobileClose.addEventListener('click', handlefilterMobileTriggerClose);
    function handlefilterMobileTriggerClose(event) {
        //console.log(event);
        searchFilterEl.classList.remove('show');
        document.body.classList.remove('show-filter');
    }

    filterMobileTrigger.addEventListener('click', handlefilterMobileTriggerAction);
    function handlefilterMobileTriggerAction(event) {
        //console.log(event);
        searchFilterEl.classList.toggle('show');
        document.body.classList.add('show-filter');
    }

    directoryFilters.addEventListener('click', toggleFilterGroup );
    function toggleFilterGroup( event ) {

        console.log( event );
        if ( ! event.target.classList.contains('filter-header') ) {
            return false;
        }

        const filterGroups = document.querySelectorAll('.directory-filter-dropdown');
        [...filterGroups].forEach( group => {
            group.classList.remove('show');
        });

        const filterGroup = event.target.closest('.directory-filter');
        const dropdown = filterGroup.querySelector('.directory-filter-dropdown');
        dropdown.classList.toggle('show');

        document.body.addEventListener('click', function(event){
            if ( 
                ! event.target.classList.contains('filter-header') 
                && 
                ! event.target.classList.contains('directory-filter-checkbox') 
                && 
                ! event.target.classList.contains('directory-filter') 
                && 
                ! event.target.classList.contains('directory-filter-label')
                &&
                ! event.target.classList.contains('facetwp-location')
                &&
                ! event.target.classList.contains('facetwp-radius')
                &&
                ! event.target.classList.contains('facetwp-checkbox')
                &&
                ! event.target.classList.contains('facetwp-date')
                &&
                ! event.target.classList.contains('facetwp-number')
                ) {
                dropdown.classList.remove('show');
            }
        });
    }
}